import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0edfba10&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0edfba10&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edfba10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0edfba10')) {
      api.createRecord('0edfba10', component.options)
    } else {
      api.reload('0edfba10', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0edfba10&scoped=true", function () {
      api.rerender('0edfba10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PhoneUserSelect/index.vue"
export default component.exports